<script>
import Banner from '../components/PageBanner';
import Title from '../components/PageTitle';
import Tab from '../components/PageTab';
import TabMenu from '../components/PageTabMenu';
import Footer from '../components/Footer';

export default {
  name: 'PageBackoffice',
  components :{
    Banner,
    Title,
    Tab,
    TabMenu,
    Footer,
  },
  mounted(){
    var currentUrl = window.location.pathname;
    if(currentUrl === "/backoffice"){
      this.$router.push({ name: 'addagence'}) //Page par défaut tout en gardant le surligne de "Paramètres" dans le menu quelque soit le children
    }
  }
}

</script>

<template>
    <div class="page-main">
      <Banner bannerImage="bannerDebug" hasAvatar=0 />
      <Title title="BackOffice" />


      <TabMenu item1=100>
        <template v-slot:body>
          <Tab text="Agences"  :route= "{name: 'addagence'}" customWidth=150 />
          <Tab text="Importer"  :route= "{name: 'importer'}" customWidth=150 />
          <Tab text="Permissions"  :route= "{name: 'application'}" customWidth=150 />
        </template>
      </TabMenu>

      <div class="page-main-container">
        <router-view></router-view>
      </div>

      <Footer />
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;

</style>
